export default "__VITE_ASSET__qE1I3mdz__"